import React from "react";
import shop from "../assets/imgTwo/business-still.svg";
import machine from "../assets/imgTwo/machine.jpg";
import phone from "../assets/imgTwo/bluePhone.jpg";
import trader from "../assets/imgTwo/trader.png";
import cash from "../assets/imgTwo/cash.jpg";
import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const services = [
  {
    title: "Agency Banking",
    description:
      "Your business can expand financial access by offering cash withdrawals and deposits through a network of agents.",
    image:trader,
  },
  {
    title: "Payment Collection Solutions",
    description:
      "SMEs can accept payments via multiple channels, including payment links, virtual accounts, and POS terminals.",
    image:cash,
  },
  {
    title: "Disbursement Services",
    description:
      "SMEs can perform payments for suppliers and business expenses.",
    image:machine,
  },
  {
    title: "Digital Banking as a Service",
    description:
      "Access customized banking solutions to scale your business with ease.",
    image:phone,
  },
];

export const WhatSMEsCanAchieve = () => {
  return (
    <div className="py-12 px-6 bg-[#F7F7F7]">
      <h2 className="text-3xl font-bold text-center mb-10">
        What SMEs Can Achieve with <br />
        <span className="text-black">Uniswitch</span>
      </h2>

      <div className="max-w-6xl mx-auto grid md:grid-cols-12 gap-6">
        <div className="md:col-span-5 flex flex-col gap-6">
          {services.slice(0, 2).map((service, index) => (
            <div
              key={index}
              className="relative rounded-xl overflow-hidden group flex-1 h-[300px] transition-all duration-500 hover:h-[320px] cursor-pointer shadow-lg"
            >
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center p-6">
                <h3 className="text-white text-2xl font-semibold mb-2">
                  {service.title}
                </h3>
                <p className="text-white text-sm">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="md:col-span-7 flex flex-col gap-6">

          <div className="relative rounded-xl overflow-hidden group transition-all duration-500 cursor-pointer shadow-lg flex-grow basis-[60%] hover:basis-[70%]">
            <img
              src={services[1].image}
              alt={services[1].title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center p-6">
              <h3 className="text-white text-2xl font-semibold mb-2">
                {services[1].title}
              </h3>
              <p className="text-white text-sm">{services[1].description}</p>
            </div>
          </div>

          <div className="relative rounded-xl overflow-hidden group transition-all duration-500 cursor-pointer shadow-lg flex-grow basis-[40%] hover:basis-[80%]">
            <img
              src={services[3].image}
              alt={services[3].title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center p-6">
              <h3 className="text-white text-2xl font-semibold mb-2">
                {services[3].title}
              </h3>
              <p className="text-white text-sm">{services[3].description}</p>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};









const HeroSection = () => {
  return (
    <section
      id="about"
      className=" bg-[#FFFFFF] md:px-[5em] py-16 animate-slidein"
    >
      <div className="container px-2 md:px-0 mx-auto flex flex-col-reverse justify-between md:flex-row items-center">
        <div className="w-full md:w-1/2 p-4">
          <h2 className="text-2xl md:text-[2.5rem] font-bold mb-4 leading-normal">
            Empowering SMEs with<br></br> Seamless Financial<br></br> Solutions     </h2>
          <p className="text-gray-800 text-lg">
            Small businesses often struggle with managing cash flow, collecting payments from customers, and making timely disbursements to employees and vendors.                  </p>


        </div>
        <div className="w-full md:w-[35em] p-2 flex md:justify-end">
          <img src={shop} alt="sarepay" className="rounded-lg" />

        </div>
      </div>
    </section>
  );
};



export const SmallBusinesses = () => (
  <div className="font-san mx-auto bg-[#FFFFFF] pt-6">
    <Navbar />
    <HeroSection />
   {/*  <AboutSection /> */}
    <WhatSMEsCanAchieve />
    <Footer />
  </div>
);

export default SmallBusinesses;
